import { weatherlimit } from "../models/vessel-weather-model";
import { authFetchGET, authFetchPOST } from "../utils/auth-fetch";
import { VoyageImoModel } from "../models/voyage-imo-model";

const configApi = (<any>window)["appenv"].services.configApi;
const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const env = { ...configApi, ...isVesselOnCloud ? { scope: (<any>window)["appenv"].scope } : {} };

export interface getWeatherLimits {
    avoid: weatherlimit
    warn: weatherlimit
}

export interface getFeatureFlags
{
  id: number,
  featureFlags: string[],
  createdAt: string,
  updatedAt: string,
  isActive: boolean,
}

export class ConfigService {
    static async fetchConfigData(): Promise<getWeatherLimits> {
        try {
            const apiUrl= isVesselOnCloud ? `getvesselweatherlimit/${VoyageImoModel?.imo!}` : 'weatherlimit';
            const data = await authFetchGET(env.scope,`${env.baseurl}/${apiUrl}`);

            return data
        } catch (error) {
            console.warn(error)
            return error as getWeatherLimits
        }
    }


    static async getFeatureFlags(): Promise<getFeatureFlags> {
        try {
            const apiUrl= isVesselOnCloud ? `featureflags/enabled/${VoyageImoModel?.imo!}` : 'featureflags/enabled';
            const data = await authFetchGET(env.scope, `${env.baseurl}/${apiUrl}`);
            if(data) {
                return data;
            }
            else {
                return {
                    "id": 0,
                    "featureFlags": [],
                    "createdAt": new Date().toISOString(),
                    "updatedAt": new Date().toISOString(),
                    "isActive": false
                };
            }
        } catch (error) {
            console.warn(error);
            return {
                "id": 0,
                "featureFlags": [],
                "createdAt": new Date().toISOString(),
                "updatedAt": new Date().toISOString(),
                "isActive": false
            };
        }
    }

    static async postConfigData(weatherLimitValue: any): Promise<any> {
        try {
            const apiUrl= isVesselOnCloud ? `upsertvesselweatherlimit/${VoyageImoModel?.imo!}` : 'weatherlimit';
            const response = await authFetchPOST(env.scope, `${env.baseurl}/${apiUrl}`, weatherLimitValue);
            const data = await response.json()
            return data
        } catch (error) {
            return null
        }
    }
    //check the health of the service
    async checkMetricsHealth(): Promise<boolean> {
        const baseUrl = env.baseurl.replace(/\/v1\/?$/, '')
        const url = `${baseUrl}/metrics`
        const timeout = 5000 // 5 seconds timeout

        try {
            const response = await Promise.race([
                authFetchGET(env.scope, url), // assuming this returns a Response object
                new Promise<never>((_, reject) =>
                    setTimeout(
                        () => reject(new Error('Request timed out')),
                        timeout,
                    ),
                ),
            ])

            // Just check for HTTP 200 OK
            if (response.status === 200) {
                return true
            } else {
                console.error(
                    `Metrics endpoint returned status: ${response.status}`,
                )
                return false
            }
        } catch (error) {
            if (error instanceof Error) {
                console.error('Metrics health check failed:', error.message)
            }
            return false
        }
    }
}
